// TODO: Move to config file or similar, for safety and that they are not tracked in git
const googleAPIKey = "AIzaSyAYsPIzW_8UN0mfeERc5Yprz4Qeq_9NaQQ";
const STRIPE_PUBLISHABLE_KEY =
  "pk_test_51GvrUXKFmT658hFDQw9CN9mW4jytXIoa5HtqSRURGSBHlJQqXM6tNCZZO5I7izIJjjjpIj4FHepMmlupRO1Etaxh00POnYJPyV";

export { googleAPIKey, STRIPE_PUBLISHABLE_KEY };
